[
  {
    "key": "kereta",
    "title": "CARii Kereta",
    "description": "Book a car by the hour from your own campus lot.",
    "icon": "directions_car",
    "status": "live",
    "href": "https://cars.carii.org",
    "ctaLabel": "Book a car"
  },
  {
    "key": "carpool",
    "title": "CARii Carpool",
    "description": "Share empty seats on trips students are already making.",
    "icon": "directions_car",
    "status": "coming_soon",
    "href": null,
    "ctaLabel": null
  },
  {
    "key": "ebike",
    "title": "CARii eBike",
    "description": "Short campus hops on shared electric bikes.",
    "icon": "bolt",
    "status": "coming_soon",
    "href": null,
    "ctaLabel": null
  },
  {
    "key": "kerja",
    "title": "CARii Kerja",
    "description": "Part-time gigs and student jobs on the same network.",
    "icon": "work",
    "status": "coming_soon",
    "href": null,
    "ctaLabel": null
  },
  {
    "key": "insurance",
    "title": "CARii Insurance",
    "description": "Cover that protects hosts and renters on every booking.",
    "icon": "verified",
    "status": "coming_soon",
    "href": null,
    "ctaLabel": null
  },
  {
    "key": "makan",
    "title": "CARii Makan",
    "description": "Student-run food runs and bungkus deliveries.",
    "icon": "restaurant",
    "status": "coming_soon",
    "href": null,
    "ctaLabel": null
  },
  {
    "key": "more",
    "title": "Coming soon",
    "description": "We're building the rest with students.",
    "icon": "more_horiz",
    "status": "in_the_works",
    "href": null,
    "ctaLabel": null
  }
]
